import { Quote } from "lucide-react";
import { motion } from "framer-motion";
import { TESTIMONIALS } from "../../lib/site";
import { Eyebrow, Reveal } from "./Motion";

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="relative px-5 py-24 sm:px-8 sm:py-32 lg:px-12">
    <div className="mx-auto max-w-[1400px]">
      <div className="grid gap-8 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <Eyebrow>Client Words</Eyebrow>
          <h2 className="font-display mt-5 text-4xl leading-[1.02] text-white sm:text-5xl lg:text-6xl">
            Clarity, shared in <span className="italic gold-text">their own words</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-6 lg:col-start-7 lg:self-end">
          <p className="text-base leading-relaxed text-slate-300">
            People come to us from across Calgary with questions about love, work, family and purpose. Here is what a session can feel like.
          </p>
          <p data-testid="testimonials-sample-notice" className="mt-4 inline-block border border-dashed border-[#D4AF37]/40 px-3 py-1.5 text-xs uppercase tracking-[0.2em] text-[#F3E5AB]">
            Sample testimonials — genuine client quotes coming soon
          </p>
        </Reveal>
      </div>
      <div className="mt-14 grid gap-5 md:grid-cols-2">
        {TESTIMONIALS.map((t, i) => (
          <motion.figure
            key={i}
            data-testid={`testimonial-card-${i}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay: (i % 2) * 0.1 }}
            className={`relative border border-[#D4AF37]/15 bg-[#0E081D]/70 p-8 sm:p-10 ${i % 2 === 1 ? "md:translate-y-10" : ""}`}
          >
            <Quote className="h-8 w-8 text-[#D4AF37]/60" strokeWidth={1} />
            <blockquote className="font-display mt-5 text-2xl leading-snug text-slate-100 sm:text-[28px]">“{t.quote}”</blockquote>
            <figcaption className="mt-8 flex items-center justify-between border-t border-[#D4AF37]/10 pt-5 text-sm">
              <span className="text-slate-200">{t.name}</span>
              <span className="font-cinzel text-[11px] tracking-[0.2em] text-[#D4AF37]">{t.meta.toUpperCase()}</span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
